import { Link } from "@inertiajs/inertia-react";
import Icon from "app/components/Icon";
import Img from "app/components/Image";
import { MODALS, ModalsContext } from "app/components/Layouts/Modals";
import { TaskType } from "app/components/Types/TaskType";
import { UserType } from "app/components/Types/UserType";
import moment, { duration } from "moment";
import { useState } from "react";
import { createContext } from "react";
import { useContext } from "react";
import route from "ziggy-js";
import IconText from "./IconText";
import { EditMenuContext } from "./TaskCard";
import { UserAvatar } from "./UserAvatar";


export function UserCard({ user }: { user: UserType; }) {

    let { open, modal } = useContext(ModalsContext);

    const { opened, setOpened } = useContext(EditMenuContext);



    return (
        <Link href={route('team.show', { user: user.UUID })} className="p-18px pt-12px bg-gray-1C1C1C rounded flex gap-24px items-center">
            <UserAvatar user={user} />
            <div className="flex justify-between items-center grow">
                <div className="flex flex-col">
                    <div>{user.name}</div>
                    <div className="text-gray-CCCCCC">{user?.role?.name ?? 'No role'}</div>
                </div>
                <div className="flex gap-32px items-center">
                    <div className={`flex items-center gap-x-8px relative p-8px ${(opened?.id == user.id && opened?.type == 'user') ? 'bg-gray-343434 rounded-t-full withInverse' : 'hover:bg-white/5 rounded-full'}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpened((opened?.id == user.id && opened.type == 'user') ? null : { id: user.id, type: 'user' }) }}>
                        <Icon className={"text-white"} name="more"  />
                        {
                            (opened?.id == user.id && opened.type == 'user') &&
                            <div className="absolute flex flex-col justify-start items-end right-0 bottom-1px translate-y-full" onClick={e => e.stopPropagation()}>
                                <div className="bg-gray-343434 rounded-md rounded-tr-none  flex flex-col gap-2px font-semibold z-10 overflow-hidden">
                                    <IconText className="hover:bg-white/5 px-20px py-15px " onClick={e => { e.preventDefault(); e.stopPropagation(); open(MODALS.EDITROLE, false, { user: user }); }} icon="pen" text="Edit role" />
                                    {/* <IconText className="text-red-FF0539 hover:bg-white/5 px-20px py-15px " icon="bin" text="Delete" /> */}
                                </div>
                            </div>
                        }
                    </div>
                    <Icon name="dropdown-arrow" className="-rotate-90 text-gray-CCCCCC" />
                </div>
            </div>
        </Link>
    );
}
